interface PhoneNumberCalloutProps {
  callHref: string;
  callNumber: string;
  className?: string;
}

interface QuoteAdviceActionsProps extends PhoneNumberCalloutProps {
  onBook: () => void;
  buttonClassName: string;
  actionsClassName: string;
}

export function PhoneNumberCallout({
  callHref,
  callNumber,
  className = "",
}: PhoneNumberCalloutProps) {
  return (
    <div className={className}>
      <span>Or call <strong>FREE</strong> on</span>
      <a href={callHref}>
        <i className="bi bi-telephone" aria-hidden="true"></i>
        <strong>{callNumber}</strong>
      </a>
    </div>
  );
}

export function QuoteAdviceActions({
  onBook,
  buttonClassName,
  actionsClassName,
  callHref,
  callNumber,
  className = "",
}: QuoteAdviceActionsProps) {
  return (
    <div className={actionsClassName}>
      <button type="button" className={buttonClassName} onClick={onBook}>
        GET FREE EXPERT ADVICE
      </button>
      <PhoneNumberCallout
        callHref={callHref}
        callNumber={callNumber}
        className={className}
      />
    </div>
  );
}
